import React from "react";

export default function Statement() {
  return (
    <section
      data-testid="statement-section"
      className="border-y border-stone-200 bg-stone-50 py-20 sm:py-28"
    >
      <div className="mx-auto max-w-6xl px-6 text-center">
        <p className="mb-6 text-xs uppercase tracking-[0.3em] text-orange-800">
          Le double métier SAD
        </p>
        <h2 className="text-3xl font-light leading-[1.1] tracking-tight text-stone-900 sm:text-5xl lg:text-6xl">
          Nous concevons les espaces{" "}
          <span className="italic text-stone-500">ET</span> le mobilier
          <br />
          <span className="italic text-orange-800">qui les compose.</span>
        </h2>
      </div>
    </section>
  );
}
